import { FC } from 'react';
import styles from './CoBrandingV2.module.scss';

export type TCoBrandingProps = {
    logoUrl: string;
    name: string;
};

const CoBrandingV2: FC<TCoBrandingProps> = (props) => {
    const { logoUrl, name } = props;
    return logoUrl ? (
        <span className={styles.coBrandedLogo} data-testid="cobranded-logo">
            <span>
                <img src={logoUrl} title={name} alt={name} />
            </span>
        </span>
    ) : (
        <section className={styles.coBrandedName} data-testid="cobranded-name">
            {name}
        </section>
    );
};

export default CoBrandingV2;
